import api from "./api";
export default {
  //获取dwg-mim格式模型结构树
  treeList: `${api.base_url}/public/mim/tree`,
};



// WEBPACK FOOTER //
// ./src/url/mim.js